module.exports = __webpack_public_path__ + "img/pin-matriz.3d768978.png";